<template>
	<div class="leftbar" v-bind:class="{ on: isActive }">
		<a class="left_nav_btn" v-bind:class="{ on: isActive }" v-on:click="toggleLeftNav"></a>
		<div class="head"></div>
		<div id="searchModule" class="h_search">
		</div>
		<div class="divider"></div>
		<left-display-panel @switchBar="switchBar" v-bind:userData="userData"></left-display-panel>
	</div>
</template>

<script>
  /* eslint-disable */
  import LeftDisplayPanel from '@/components/LeftDisplayPanel'
  export default {
    name: 'LeftBar',
    props: {
        userData: {
            default: '' 
        }
    },
    data () {
      return {
        msg: 'This is left tool bar!',
        isActive: false
      }
    },
    mounted: function() {
        pfAirViewer.createGeocoder('searchModule');
        $('.cesium-geocoder-input-wide').css("width", "280px");
        $('.cesium-geocoder-input').css("width", "290px");
        $('.cesium-geocoder-input').css("background-color", "rgba(243, 243, 243, 1)");
        $('.cesium-geocoder-input').css("color", "rgba(7, 8, 12, 1)");
        $('.cesium-geocoder-searchButton').css("background-color", "rgba(18, 40, 95, 1)");
    },
    methods: {
        toggleLeftNav: function(event){
            this.isActive = !this.isActive;
        },
        switchBar: function(stateBool) {
			this.isActive = stateBool;
        }
    },
    components: {
		LeftDisplayPanel
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leftbar{
    width:320px;
    position:fixed;
    top:52px;
    left:-320px;
    background:#f3f3f3;
    height:95%;
    z-index:6; 
    transition:.3s; 
    padding:0px 0 0 0;
}
.leftbar.on{ 
    left:0;
}
.left_nav_btn{ 
    background-color:#f3f3f3; 
    cursor:pointer; 
    background-repeat:no-repeat; 
    width:34px; 
    height:40px; 
    overflow:hidden; 
    cursor:pointer;
    position:absolute; 
    right:-34px; 
    top:140px;
    cursor:pointer; 
    background-image:url('../../static/images/icon/btn_arrow.png'); 
    background-position:-34px top;
    }
.left_nav_btn.on{ 
  background-position:0 top;
}
.head {
    margin-top: 8px;
}
#searchModule {
    margin-left: 12px;
}
.divider {
    margin-left: 0px;
    margin-top: 8px;
    margin-bottom: 16px;
    height: 1px;
    background-image: linear-gradient(to left, #ccc, #ccc, #ccc);
    /*box-shadow: 5px 5px 5px 0px #888888;*/
}
</style>


// WEBPACK FOOTER //
// src/components/LeftBar.vue